import React from 'react';

import { 
    Col,
    Card
 } from "react-bootstrap";
const CardLayout = ({data}) => {
    return ( 
        <Col lg="12">
            <div className="pb-5 text-center">
                <img className=" bg-white mb-3" src={data.companylogo} alt=""/>
                <p className="lead">
                    {data.role}
                    <br/>
                    {data.date}
                </p>
                
            </div>
        </Col>
     );
}
 
export default CardLayout;